import { removeSessionPartnership } from '../../services/sessionPartnershipService';
import { OFFLINE_COMMAND_TYPES, shouldRunLocalHostPath } from './offlineQueueConstants';

export async function removeSessionPartnershipMaybeOffline({
  sessionId,
  player1Id,
  player2Id,
  offlineQueue,
  session,
  snapshot,
}) {
  if (shouldRunLocalHostPath(offlineQueue, session) && typeof offlineQueue?.enqueue === 'function') {
    await offlineQueue.enqueue(
      {
        type: OFFLINE_COMMAND_TYPES.PARTNERSHIP_REMOVE,
        player1Id,
        player2Id,
      },
      snapshot
    );
    return { success: true, local: true };
  }
  return removeSessionPartnership(sessionId, player1Id, player2Id);
}
